/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Rest_ChannelInputs */

const en_us2_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest timer`)
};

const pt_br2_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alarme de descanso`)
};

const es_419_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de descanso`)
};

const pt_pt2_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alarme de descanso`)
};

const fr_fr2_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur de repos`)
};

const de_de2_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausentimer`)
};

const it_it2_offline_rest_channel = /** @type {(inputs: Offline_Rest_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer di recupero`)
};

/**
* | output |
* | --- |
* | "Rest timer" |
*
* @param {Offline_Rest_ChannelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_rest_channel = /** @type {((inputs?: Offline_Rest_ChannelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Rest_ChannelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_rest_channel(inputs)
	if (locale === "es-419") return es_419_offline_rest_channel(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_rest_channel(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_rest_channel(inputs)
	if (locale === "de-DE") return de_de2_offline_rest_channel(inputs)
	if (locale === "it-IT") return it_it2_offline_rest_channel(inputs)
	return en_us2_offline_rest_channel(inputs)
});
export { offline_rest_channel as "offline.rest_channel" }